import React, { useState } from 'react'

import ButtonContainer from 'components/CarSettings/Common/Creation/ButtonContainer'
import LocationSection from 'components/Common/Location'
import {
  ContainerStyles,
  StyledBox,
  StyledContainer,
} from 'components/Operations/Dealer/Creation/DealerLocation/style'

import { CURBO_SPOT_CREATION_OPTION } from 'constants/Operation/curboSpot'
import { textFiles } from 'constants/textFiles'
import useTranslation from 'hooks/useTranslation'
import { Address } from 'models/map'
import { SpotCreationProps } from 'utils/CurboSpot/creation'

const Location = ({
  spotData,
  handleBack,
  handleContinue,
  updateSpotData,
}: SpotCreationProps) => {
  const { spotLocation } = spotData

  const [error, setError] = useState<boolean>(false)

  const [address, setAddress] = useState<Address | undefined>(
    spotLocation.address
  )
  const { text } = useTranslation(textFiles.CURBO_SPOT_CREATION)

  const { location: translation } = text

  const handleSubmit = () => {
    if (address === undefined) {
      setError(true)
    } else {
      updateSpotData({
        type: CURBO_SPOT_CREATION_OPTION.UPDATE_CURBO_SPOT_LOCATION,
        payload: { address },
      })
      handleContinue()
    }
  }

  const handleAddressChange = (newAddress: Address | undefined) => {
    setAddress(newAddress)
    setError(false)
  }

  return (
    <StyledBox>
      <StyledContainer>
        <LocationSection
          translation={translation}
          address={address}
          showError={error}
          handleAddressChange={handleAddressChange}
          containerStyling={ContainerStyles}
          hasCoordinatePicker
          curboSpots={[]}
          circleCenter={
            address ? { lat: address.lat, lng: address.lng } : undefined
          }
          mapHeight="90%"
        />
      </StyledContainer>
      <ButtonContainer
        previousFunction={handleBack}
        nextFunction={handleSubmit}
        confirmButtonType="button"
        textType="next"
      />
    </StyledBox>
  )
}

export default Location
